import {AbstractControl} from '@angular/forms';
import * as moment from 'moment';

export function ValidatePassedDate(control: AbstractControl) {
  return moment(control.value, 'DD-MM-YYYY').toDate() <= new Date() ? null : {validPassedDate: true};
}
